import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Report a Claim', icon: 'ri-file-list-3-line', href: '/service-center#claim' },
  { label: 'Auto ID Card', icon: 'ri-id-card-line', href: '/service-center#auto-id' },
  { label: 'Get Certificate', icon: 'ri-folder-open-line', href: '/service-center#certificate' },
  { label: 'Policy Change', icon: 'ri-edit-box-line', href: '/service-center#policy-change' },
];

export default function ManagePolicies() {
  return (
    <section className="relative overflow-hidden min-h-[500px] flex items-stretch">
      {/* Background Image (left half visible) */}
      <div
        className="hidden lg:block absolute left-0 top-0 bottom-0 w-1/2 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://b3533217.smushcdn.com/3533217/wp-content/uploads/2024/12/Homepage-Scenic-View-of-a-Historic-Water-Wheel-Mill-at-a-Park-in-Canton-Georgia-During-the-Fall.jpg?lossy=2&strip=1&webp=1)',
        }}
      />

      {/* Dark panel on right */}
      <div className="relative z-10 ml-auto w-full lg:w-1/2 bg-[#0b2240]/95 px-10 md:px-14 py-16 flex flex-col justify-center">
        <h2 className="text-3xl font-bold text-white mb-3">Manage Your Policies</h2>
        <p className="text-white/70 text-sm mb-8 leading-relaxed">
          Already a client? Visit our Service Center to make requests and manage your insurance policies.
        </p>

        <div className="grid grid-cols-2 gap-3 mb-6">
          {serviceLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="flex flex-col items-center justify-center gap-2 text-center border border-white/20 rounded-md px-4 py-5 text-white hover:bg-[#3072b7]/30 transition-colors group"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${link.icon} text-2xl text-[#9cbde5]`} />
              </div>
              <span className="text-xs font-semibold">{link.label}</span>
            </Link>
          ))}
        </div>

        <Link
          to="/service-center"
          className="block w-full text-center bg-[#3072b7] hover:bg-white hover:text-[#0b2240] text-white font-bold text-sm py-3.5 rounded-md transition-colors"
        >
          Visit Service Center
        </Link>
      </div>
    </section>
  );
}
